/* PrimeBuild – Tenis: página detallada del Tennis Rebound Trainer (plantilla product.tenis).
   El nombre de la cabecera, de la barra fija y del aviso del carrito es el de la ficha normal
   (no se cambia aquí); solo se pone el nombre claro del pack ("1 Base + 3 Balls").
   - Selector de packs del módulo de compra y guía de packs: al elegir un pack se cambia la
     variante del selector original de Shopify (oculto), así el precio, la foto, el botón de
     añadir al carrito y la barra fija siguen funcionando como siempre.
   - Todo lo que depende del pack elegido (nombre, precio real, "qué trae") se actualiza solo.
   - Al entrar, si estaría elegido un recambio sin base, se elige el pack indicado (1 Base 1 Ball).
   - El botón "Añadir al carrito" del cierre usa el botón del módulo de compra.
   - Galería de fotos (bloque "Tenis: galería de fotos"): fotos que se deslizan, miniaturas,
     flechas y la foto del pack elegido (la foto de la variante en Shopify), que cambia sola.
   - "Choose your pack" y "Change pack" suben al selector y ponen el foco en el pack elegido.
   - Mientras se ve la caja del cierre, la barra fija de compra de Shopify se aparta (no hay
     dos botones de añadir al carrito uno encima de otro).
   Los precios vienen de Shopify (ya con formato), nunca se calculan aquí. */
(function () {
  if (window.__pbtInit) return;
  window.__pbtInit = true;

  var V = {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    document.querySelectorAll('script[data-pbt-variants]').forEach(function (s) {
      try {
        JSON.parse(s.textContent).forEach(function (v) {
          // El primero que aparece (el selector del módulo de compra) manda
          V[String(v.id)] = Object.assign({}, v, V[String(v.id)] || {});
        });
      } catch (e) {}
    });
  }

  function productSection() {
    var sel = document.querySelector('[data-pbt-selector]');
    return (sel && sel.closest('.shopify-section')) || document.querySelector('.shopify-section:has(product-form-component)');
  }
  function picker() {
    var sec = productSection();
    return (sec && sec.querySelector('variant-picker')) ||
      document.querySelector('variant-picker[data-template-product-match="true"]');
  }
  function productForm() {
    var sec = productSection();
    return (sec && sec.querySelector('product-form-component')) || document.querySelector('product-form-component');
  }
  function currentId() {
    var f = productForm();
    var i = f && f.querySelector('input[name="id"]');
    if (i && i.value) return String(i.value);
    var el = document.querySelector('[data-pbt-current]');
    return el ? el.getAttribute('data-pbt-current') : null;
  }

  /* ---------- Elegir un pack ---------- */
  function selectVariant(id) {
    id = String(id);
    if (!V[id]) collect();
    var v = V[id];
    if (!v) return false;
    var vp = picker();
    if (vp) {
      var radios = vp.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        if (r.value === v.value || r.getAttribute('data-variant-id') === id) {
          if (!r.checked) r.click();
          render(id);
          return true;
        }
      }
      var select = vp.querySelector('select');
      if (select) {
        for (var j = 0; j < select.options.length; j++) {
          if (select.options[j].value === v.value) {
            select.value = v.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            render(id);
            return true;
          }
        }
      }
    }
    // Sin selector de Shopify: recargar con la variante en la dirección
    var u = new URL(window.location.href);
    u.searchParams.set('variant', id);
    window.location.href = u.toString();
    return false;
  }

  /* ---------- Pintar el pack elegido en todas partes ---------- */
  function render(id) {
    if (!id) return;
    id = String(id);
    var v = V[id];

    document.querySelectorAll('[data-pbt-radio]').forEach(function (r) {
      r.checked = r.value === id;
    });
    document.querySelectorAll('[data-pbt-card]').forEach(function (c) {
      var on = c.getAttribute('data-pbt-card') === id;
      c.classList.toggle('is-selected', on);
      var b = c.querySelector('[data-pbt-pick]');
      if (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var t = b.querySelector('[data-pbt-btn-text]');
        if (t) t.textContent = on ? b.getAttribute('data-label-on') : b.getAttribute('data-label');
      }
    });
    if (!v) return;

    document.querySelectorAll('[data-pbt-sel-name]').forEach(function (el) { el.textContent = v.name || v.title; });
    document.querySelectorAll('[data-pbt-sel-price]').forEach(function (el) { el.textContent = v.price; });
    document.querySelectorAll('[data-pbt-contents]').forEach(function (el) {
      if (v.contents) el.textContent = v.contents;
      el.classList.toggle('is-refill', !v.nb);
    });
    document.querySelectorAll('[data-pbt-atc]').forEach(function (b) {
      b.disabled = !v.available;
      var t = b.querySelector('[data-pbt-atc-text]');
      if (t) t.textContent = v.available ? (b.getAttribute('data-label') + ' · ' + v.price) : b.getAttribute('data-label-sold');
    });
    stickyLabels(v);
    galleryPack(v);
  }

  /* ---------- Galería de fotos ---------- */
  function galleryMount() {
    var g = document.querySelector('[data-pbt-gal]');
    if (!g) return null;
    var sec = g.closest('.product-information');
    var col = sec && sec.querySelector('.product-information__media');
    if (!col) return null;
    if (g.parentNode !== col) col.insertBefore(g, col.firstChild);
    col.classList.add('pbt-gal-on');
    g.hidden = false;
    if (!g.__pbtGal) galleryWire(g);
    return g;
  }

  function galleryWire(g) {
    var track = g.querySelector('[data-pbt-gal-track]');
    if (!track) return;
    var slides = [].slice.call(g.querySelectorAll('[data-pbt-gal-slide]'));
    var thumbs = [].slice.call(g.querySelectorAll('[data-pbt-gal-thumb]'));
    var cur = -1;
    var ticking = false;
    var target = null;
    var targetTimer = 0;
    function mark(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function go(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      // Mientras se desliza hasta la foto pedida, las miniaturas no saltan por las fotos intermedias
      target = i;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = null; }, 1500);
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    g.__pbtGal = { go: go, pack: slides.indexOf(g.querySelector('[data-pbt-gal-pack]')) };
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (target !== null) {
          if (i !== target) return;
          target = null;
        }
        if (slides[i]) mark(i);
      });
    }, { passive: true });
    track.addEventListener('scrollend', function () {
      target = null;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (slides[i]) mark(i);
    });
    // Si la persona desliza con el dedo o el ratón, manda lo que ve
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { target = null; }, { passive: true });
    });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { go(k); });
    });
    var prev = g.querySelector('[data-pbt-gal-prev]');
    var next = g.querySelector('[data-pbt-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    // Si cambia el ancho (girar el móvil, cambiar la ventana), seguir en la misma foto
    if ('ResizeObserver' in window) {
      var lastW = track.clientWidth;
      new ResizeObserver(function () {
        if (track.clientWidth !== lastW) { lastW = track.clientWidth; if (cur >= 0) track.scrollLeft = cur * lastW; }
      }).observe(track);
    }
    mark(0);
  }

  /* Poner la foto del pack elegido; con show = true, además se enseña esa foto */
  function galleryPack(v, show) {
    var g = document.querySelector('[data-pbt-gal]');
    if (!g || !v) return;
    var img = g.querySelector('[data-pbt-gal-pack-img]');
    var th = g.querySelector('[data-pbt-gal-pack-timg]');
    var slide = g.querySelector('[data-pbt-gal-pack]');
    var name = v.name || v.title;
    if (img && v.img && img.getAttribute('data-pbt-for') !== String(v.id)) {
      img.setAttribute('data-pbt-for', String(v.id));
      if (v.imgSet) img.setAttribute('srcset', v.imgSet);
      img.setAttribute('src', v.img);
      var label = slide && slide.querySelector('.pbt-gal__cap span');
      var word = (label && label.textContent.trim()) || 'Your pack';
      img.setAttribute('alt', word + ': ' + name);
      if (th && v.thumb) th.setAttribute('src', v.thumb);
      var tb = g.querySelector('[data-pbt-gal-pack-thumb]');
      if (tb) {
        var pos = (tb.getAttribute('aria-label') || '').split(':')[0];
        tb.setAttribute('aria-label', pos + ': ' + word + ': ' + name);
      }
    }
    if (show && g.__pbtGal && g.__pbtGal.pack > -1) g.__pbtGal.go(g.__pbtGal.pack);
  }

  /* Barra fija de compra: el nombre claro del pack (el nombre del producto lo pone la ficha normal).
     La foto pequeña es decorativa (al lado ya están el nombre y el pack): alt vacío, así no se lee
     el texto largo del proveedor que traen las fotos de las variantes. */
  function stickyLabels(v) {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var vt = bar.querySelector('.sticky-add-to-cart__variant');
    if (vt && v && v.name && vt.textContent !== v.name) vt.textContent = v.name;
    var im = bar.querySelector('.sticky-add-to-cart__image-img');
    if (im && im.getAttribute('alt') !== '') im.setAttribute('alt', '');
  }

  /* Mientras se ve la caja del cierre (con su propio "Add to cart"), la barra fija de Shopify se aparta */
  var finalReady = false;
  function initFinal() {
    if (finalReady || !('IntersectionObserver' in window)) return;
    var boxes = document.querySelectorAll('.pbt-final__box');
    if (!boxes.length) return;
    finalReady = true;
    var vis = new Map();
    var root = document.documentElement;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { vis.set(en.target, en.isIntersecting); });
      var on = false;
      vis.forEach(function (x) { if (x) on = true; });
      root.classList.toggle('pbt-final-on', on);
    });
    boxes.forEach(function (b) { io.observe(b); });
  }

  /* ---------- Subir hasta la compra ---------- */
  function goToBuy(focusSelector) {
    var target = document.getElementById('pbx-comprar') || document.querySelector('[data-pbt-selector]');
    var sel = document.querySelector('[data-pbt-selector]');
    var anchor = sel || target;
    if (!anchor) return;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - 110;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (focusSelector && sel) {
      var r = sel.querySelector('[data-pbt-radio]:checked') || sel.querySelector('[data-pbt-radio]');
      if (r) setTimeout(function () { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } }, reduce ? 0 : 450);
    }
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-pbt-radio]')) {
      selectVariant(t.value);
      galleryPack(V[String(t.value)], true);
    }
  });

  document.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('[data-pbt-pick]');
    if (pick) {
      e.preventDefault();
      selectVariant(pick.getAttribute('data-pbt-pick'));
      galleryPack(V[String(pick.getAttribute('data-pbt-pick'))], true);
      goToBuy(true);
      return;
    }
    var go = e.target.closest && e.target.closest('[data-pbt-go="buy"]');
    if (go && document.querySelector('[data-pbt-selector]')) {
      e.preventDefault();
      // El foco va al pack elegido (teclado y lectores de pantalla siguen el salto)
      goToBuy(true);
      return;
    }
    var atc = e.target.closest && e.target.closest('[data-pbt-atc]');
    if (atc) {
      e.preventDefault();
      var f = productForm();
      var btn = f && f.querySelector('[ref="addToCartButton"]');
      if (btn && !btn.disabled) {
        btn.dataset.puppet = 'true';
        btn.click();
      } else {
        goToBuy(true);
      }
    }
  });

  document.addEventListener('variant:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (r && r.id) {
      render(String(r.id));
      // La barra fija se vuelve a pintar con los textos de Shopify: volver a poner los nuestros
      setTimeout(function () { stickyLabels(V[String(r.id)]); }, 60);
      setTimeout(function () { stickyLabels(V[String(r.id)]); }, 400);
    }
  });

  document.addEventListener('cart:update', function (e) {
    var f = productForm();
    var btn = f && f.querySelector('[ref="addToCartButton"]');
    if (btn) btn.dataset.puppet = 'false';
    // Aviso "Añadido al carrito": el nombre claro del pack (el del producto lo pone la ficha normal)
    var d = e && e.detail;
    if (!d || !d.data || d.data.source !== 'product-form-component' || d.data.didError) return;
    var v = V[currentId()];
    setTimeout(function () {
      var toast = document.querySelector('.pbp-cart-toast');
      if (!toast) return;
      var vt = toast.querySelector('.pbp-cart-toast__variant');
      if (vt && v && v.name) vt.textContent = v.name;
    }, 30);
  });

  /* ---------- Inicio ---------- */
  function preselect() {
    var box = document.querySelector('[data-pbt-selector]');
    if (!box) return;
    if (/[?&]variant=/.test(window.location.search)) return;
    var cur = V[currentId()];
    if (!cur || cur.nb > 0) return;
    var want = (box.getAttribute('data-pbt-default') || '').trim().toLowerCase();
    var id, v;
    // 1) El pack indicado en el editor (si se puede comprar)
    if (want) {
      for (id in V) {
        v = V[id];
        if (v.available && (String(v.value).toLowerCase() === want || String(v.title).toLowerCase() === want)) {
          selectVariant(id);
          return;
        }
      }
    }
    // 2) Si no, el pack con base más barato que se pueda comprar
    var best = null;
    for (id in V) {
      v = V[id];
      if (!v.available || !(v.nb > 0)) continue;
      if (best === null || Number(v.cents) < Number(V[best].cents)) best = id;
    }
    if (best) selectVariant(best);
  }

  /* ---------- Móvil: barra fija antes de llegar a la compra ---------- */
  var mbarReady = false;
  function initMbar() {
    var bar = document.querySelector('[data-pbt-mbar]');
    if (!bar || mbarReady) return;
    var f = productForm();
    var buy = (f && (f.closest('.buy-buttons-block') || f)) || null;
    var ctas = document.querySelector('.pbt-hero__ctas');
    var selBox = document.querySelector('[data-pbt-selector]');
    if (!buy || !('IntersectionObserver' in window)) return;
    mbarReady = true;
    var seen = new Map();
    var link = bar.querySelector('a');
    var ticking = false;
    function update() {
      ticking = false;
      var r = buy.getBoundingClientRect();
      var notYet = r.top > window.innerHeight;
      // No tapar la portada al entrar: la barra sale en cuanto se empieza a bajar
      var moved = (window.pageYOffset || document.documentElement.scrollTop || 0) > 48;
      var on = moved && notYet && !seen.get(buy) && !(ctas && seen.get(ctas)) && !(selBox && seen.get(selBox));
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      update();
    });
    io.observe(buy);
    if (ctas) io.observe(ctas);
    if (selBox) io.observe(selBox);
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() {
    collect();
    galleryMount();
    initMbar();
    initFinal();
    // Selector listo (si no hubiera selector de Shopify, elegir un pack recarga la página con ?variant=)
    var sel = document.querySelector('[data-pbt-selector]');
    if (sel) sel.setAttribute('data-pbt-ready', '');
    document.documentElement.classList.remove('pbt-fallback');
    render(currentId());
    stickyLabels(V[currentId()]);
    // Elegir el pack por defecto cuando el selector de Shopify ya está listo
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-picker').then(function () { setTimeout(preselect, 60); });
    } else {
      preselect();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { collect(); init(); });
})();
